/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, Output, EventEmitter, ElementRef, Renderer, ViewEncapsulation } from '@angular/core';
import { HostBinding, HostListener, Inject, Optional, ContentChildren, QueryList, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE } from '@angular/forms';

import classNames from 'classnames';

import { FormControl } from '../input/form.control';
import { Radio } from './radio';


const /** @type {?} */ INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioGroup),
    multi: true
};
export class RadioGroup extends FormControl {
/**
 * 样式前缀
 */
prefixCls = 'ant-radio-group';
/**
 * 控件大小。注：只对按钮样式生效。可选 `large` `default` `small`，默认为`default`。
 */
size: 'large' | 'default' | 'small' = 'default';
/**
 * 如果设置为`button`模式，则显示RadioButton的样式
 */
mode: string;
/**
 * 用户CSS样式
 */
class: string;
/**
 * 值变更事件
 */
change = new EventEmitter<any>();
/**
 * 子列表
 */
children: QueryList<Radio>;
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} compositionMode
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private compositionMode: boolean) {

        super(renderer, elementRef, compositionMode);
    }
/**
 * 样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames(this.prefixCls, {
            [`${this.prefixCls}-${this.size}`]: this.size
        }, this.class);
        return classes;
    }
/**
 * @return {?}
 */
onClick(): void {
        this.onTouched(); // set your control to 'touched'
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
        if (value !== null) {
            this.value = value;
            // 更新子列表的checked状态
            this.toggleChildren();
        }
    }
/**
 * 当子选项发生变更时，也变更Group自身的值
 * @param {?} value
 * @param {?} checked
 * @return {?}
 */
toggle(value: any, checked: boolean): void {
        if (typeof value !== 'undefined') {
            this.value = value;
            this.onChange(this.value);
            this.change.emit(this.value);
            this.toggleChildren();
        }
    }
/**
 * 更新子列表的checked状态
 * @return {?}
 */
toggleChildren(): void {
        this.children.forEach(checkbox => {
            checkbox.checked = this.value === checkbox.value;
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-radio-group',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None,
    providers: [INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'size': [{ type: Input },],
'mode': [{ type: Input },],
'class': [{ type: Input },],
'change': [{ type: Output },],
'children': [{ type: ContentChildren, args: [forwardRef(() => Radio), { descendants: true }, ] },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

function RadioGroup_tsickle_Closure_declarations() {
/** @type {?} */
RadioGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RadioGroup.ctorParameters;
/** @type {?} */
RadioGroup.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
RadioGroup.prototype.prefixCls;
/**
 * 控件大小。注：只对按钮样式生效。可选 `large` `default` `small`，默认为`default`。
 * @type {?}
 */
RadioGroup.prototype.size;
/**
 * 如果设置为`button`模式，则显示RadioButton的样式
 * @type {?}
 */
RadioGroup.prototype.mode;
/**
 * 用户CSS样式
 * @type {?}
 */
RadioGroup.prototype.class;
/**
 * 值变更事件
 * @type {?}
 */
RadioGroup.prototype.change;
/**
 * 子列表
 * @type {?}
 */
RadioGroup.prototype.children;
/** @type {?} */
RadioGroup.prototype.renderer;
/** @type {?} */
RadioGroup.prototype.elementRef;
/** @type {?} */
RadioGroup.prototype.compositionMode;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
